import KPITrendChartListComponent from './KPITrendChartListComponent';

// eslint-disable-next-line import/no-unused-modules
export default KPITrendChartListComponent;
